export class Favourite {
    
    public bid:number;
    public uid:string;
    public model:string;
  

    constructor(bid:number,uid:string,model:string){
        
        this.bid=bid;
        this.uid=uid;
        this.model=model;
       
    }
}


// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/models/favourite.model.ts